export enum PromotionCodeTypeEnum {
  Single = 'single',
  Multiple = 'multiple'
}
